// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"595":"ec9038c5","5041":"8c5b220b","9328":"cdc6843f"}[chunkId] + ".chunk.css";
};